import React from 'react';
import { ChevronRight } from '@mui/icons-material';
import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * A button that can be clicked to navigate to a given PS section.
 * @param {object} props Props accepted by the component.
 * @param {string} props.testID Test ID to be used.
 * @param {object} props.section The PS section to use.
 * @returns {import('react').FunctionComponent} React element that contains the section button.
 */
function SectionRow({ testID, section }) {
  const [translate, i18n] = useTranslation();
  return (
    <Card
      id={testID}
      key={section.title}
      sx={{
        width: '100%',
        borderRadius: 2,
        boxShadow: 0,
      }}
    >
      <CardActionArea
        component={Link}
        to={`${section.id}?lang=${i18n.language}`}
      >
        <CardContent>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography id={`${testID}-Text`} variant="body_lg">
              {translate(section.titleLabel)}
            </Typography>
            <ChevronRight fontSize="large" />
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default SectionRow;
